import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataModel } from './data-model';
import { tap, finalize } from 'rxjs/operators';
import { LoaderService } from '../core/loader/loader.service';
import { environment } from 'src/environments/environment';


class Photo {
  index: number;
  imageData: any;
  valid: boolean;
  filename: string;
  imageDataLogo: any;
  isImage: boolean;
  contentType: string;
  sideName: string;
  IsPhotoSideValid: string;
  sideNameLabel: string;
  showRemoveBtn: boolean;
  imageSideData: string;
}

const baseUrl = environment.baseUrl;
const API_URL = baseUrl + 'api/EasyClaim/Post1';

const PHASE2_URL = baseUrl + 'api/EasyClaim/Post2';

const TimeStampSubmit_URL = baseUrl + 'api/EasyClaim/EasyClaimTimeStamp';

const EcAnalyticsStart_URL = baseUrl + 'api/EasyClaim/StartEcAnalytics';

const EcTlAcceptSubmit_URL = baseUrl + 'api/EasyClaim/PostEasyClaimTlAccept';

const EcTlDeclineSubmit_URL = baseUrl + 'api/EasyClaim/PostEasyClaimTlDecline';

const checkPerspective_URL = baseUrl + 'api/EasyClaim/PostPerpectiveImage';

const ecInternalJourney_URL = baseUrl + 'Case/CreateEcInternalJourneyCase/';

const sendEmail_URL = baseUrl + 'api/EasyClaim/SendEasyClaimDecisionEmail';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  formData: FormData = new FormData();

  photos: Photo[] = [];
  additionalPhotos: Photo[] = [];

  questions = [];

  claimId = '';
  treatmentType = '';

  submitDateTime = '';
  timeStampType = '';
  timeStampDateTime = '';
  browserName = '';
  osVersion = '';
  deviceName = '';
  analyticsid = '';
  easyClaimType = '';
  isEasyClaimTlAccept = false;
  perspectiveSides = '';
  ecInternalJourneyUrl = ecInternalJourney_URL;
  engineeringOutcome: '';

  constructor(private http: HttpClient,
    private loaderService: LoaderService) {
  }

  getFormData(): FormData {
    return this.formData;
  }

  getPhotos(): Photo[] {
    return this.photos;
  }

  setPhotos(input: Photo[]) {
    this.photos = input;
  }

  getAdditionalPhotos(): Photo[] {
    return this.additionalPhotos;
  }

  setAdditionalPhotos(input: Photo[]) {
    this.additionalPhotos = input;
  }

  getQuestions(): any[] {
    return this.questions;
  }

  setQuestions(input: any[]) {
    this.questions = input;
  }

  isPhase1(item) {
    return item.qn_number.startsWith('p1_');
  }

  getPhase1Questions(): any[] {
    return this.questions.filter(this.isPhase1);
  }

  isPhase2(item) {
    return item.qn_number.startsWith('p2_');
  }

  getPhase2Questions(): any[] {
    return this.questions.filter(this.isPhase2);
  }

  setTimeStampType(typeValue) {
    this.timeStampType = typeValue;
  }

  setTimeStampDateTime(dateTimeValue) {
    this.timeStampDateTime = dateTimeValue;
  }

  setSubmitDateTime(dateTime) {
    this.submitDateTime = dateTime;
  }

  setClaimId(cid) {
    this.claimId = cid;
  }
  setTreatmentType(treatmentTypeValue) {
    this.treatmentType = treatmentTypeValue;
  }

  setBrowserName(browserNameValue) {
    this.browserName = browserNameValue;
  }
  setDeviceName(deviceNameValue) {
    this.deviceName = deviceNameValue;
  }
  setOSVersion(osVersionValue) {
    this.osVersion = osVersionValue;
  }
  setAnalyticsId(analyticsId) {
    this.analyticsid = analyticsId;
  }
  setEasyClaimType(easyClaimType) {
    this.easyClaimType = easyClaimType;
  }

  setIsEasyClaimTlAcceptType(isEasyClaimTlAccept) {
    this.isEasyClaimTlAccept = isEasyClaimTlAccept;
  }

  getIsEasyClaimTlAcceptType(): boolean {
    return this.isEasyClaimTlAccept;
  }
  getEasyClaimType() {
    return this.easyClaimType;
  }

  setEngineeringOutcome(value) {
    this.engineeringOutcome = value;
  }

  getEngineeringOutcome() {
    return this.engineeringOutcome;
  }

  sendData(): any {

    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('Analyticsid', this.analyticsid);
    formData.append('SubmitDateTime', this.submitDateTime);
    formData.append('TreatmentType', this.treatmentType);
    var k = 0;
    this.photos.forEach((f, i) => {
      if (f.valid) {
        formData.append(`Files[${k}][Base64ImageString]`, f.imageData);
        formData.append(`Files[${k}][FileName]`, f.filename);
        formData.append(`Files[${k}][IsImage]`, f.isImage.toString());
        formData.append(`Files[${k}][ContentType]`, f.contentType);
        k = k + 1;
      }
    });
    this.additionalPhotos.forEach((f, i) => {
      if (f.valid) {
        formData.append(`Files[${k}][Base64ImageString]`, f.imageData);
        formData.append(`Files[${k}][FileName]`, f.filename);
        k = k + 1;
      }
    });
    if (this.easyClaimType == "EasyClaimTL" && this.isEasyClaimTlAccept == false) {
      this.questions = this.questions.filter(x => x.AcceptDeclineType == "decline");
    }


    this.questions.forEach((item, index) => {
      if (item.qn_number.startsWith('p1_')) {
        formData.append(`Answers[${index}][QnNumber]`, item.qn_number);
        formData.append(`Answers[${index}][Answer]`, item.Answer);
      }
    });
    this.loaderService.show();

    var submitApiUrl = API_URL;

    if (this.easyClaimType == "EasyClaimTL") {
      submitApiUrl = EcTlDeclineSubmit_URL;
    }

    const request = this.http.post<DataModel>(submitApiUrl, formData).pipe(
      finalize(() => {
        this.loaderService.hide();
      })
    );
    return request;
  }

  sendPhase2Data(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    this.questions.forEach((item, index) => {
      if (item.qn_number.startsWith('p2_')) {
        formData.append(`Answers[${index}][QnNumber]`, item.qn_number);
        formData.append(`Answers[${index}][Answer]`, item.Answer);
      }
    });
    return this.http.post(PHASE2_URL, formData);
  }

  submitTimeStamp(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('AnalyticsId', this.analyticsid);
    formData.append('Type', this.timeStampType);
    formData.append('TimeStamp', this.timeStampDateTime);
    formData.append('AddRemove', 'add');
    return this.http.post(TimeStampSubmit_URL, formData);
  }

  startEcAnalytics(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('AnalyticsId', this.analyticsid);
    formData.append('Type', this.timeStampType);
    formData.append('TimeStamp', this.timeStampDateTime);
    formData.append('Browser', this.browserName);
    formData.append('OsVersion', this.osVersion);
    formData.append('Device', this.deviceName);

    return this.http.post(EcAnalyticsStart_URL, formData);
  }

  submitEasyClaimTlAccept(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('AnalyticsId', this.analyticsid);
    formData.append('SubmitDateTime', this.submitDateTime);
    formData.append('TreatmentType', this.treatmentType);

    this.questions = this.questions.filter(x => x.AcceptDeclineType == "accept");

    this.questions.forEach((item, index) => {
      if (item.qn_number.startsWith('p1_')) {
        formData.append(`Answers[${index}][QnNumber]`, item.qn_number);
        formData.append(`Answers[${index}][Answer]`, item.Answer);
      }
    });

    return this.http.post(EcTlAcceptSubmit_URL, formData);
  }

  setPerspectiveSides(perspectiveSides) {
    this.perspectiveSides = perspectiveSides;
  }

  checkImageSides(): any {

    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('Analyticsid', this.analyticsid);
    formData.append('SubmitDateTime', this.submitDateTime);
    formData.append('treatmentType', '3');

    var k = 0;
    this.photos.forEach((f, i) => {
      if (f.valid) {
        var sideNameValue = f.sideNameLabel.toLowerCase().trim();
        if (sideNameValue != 'mileage') {
          formData.append(`Files[${k}][Base64ImageString]`, f.imageData);
          formData.append(`Files[${k}][FileName]`, f.filename);
          //formData.append(`Files[${k}][FileName]`, f.sideName);
          k = k + 1;
        }
      }
    });

    this.loaderService.show();
    const request = this.http.post<DataModel>(checkPerspective_URL, formData).pipe(
      finalize(() => {
        this.loaderService.hide();
      })
    );
    return request;
  }

  sendAutomaticEmail(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);

    return this.http.post(sendEmail_URL, formData);
  }

  deleteTimeStamp(): any {
    const formData: FormData = new FormData();
    formData.append('ClaimId', this.claimId);
    formData.append('AnalyticsId', this.analyticsid);
    formData.append('Type', this.timeStampType);
    formData.append('TimeStamp', this.timeStampDateTime);
    formData.append('AddRemove', 'remove');
    return this.http.post(TimeStampSubmit_URL, formData);
  }


}
